var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"l-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-14 col-xs-offset-2 col-sm-10 col-sm-offset-4"},[_vm._t("default")],2)])])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aeabbdf","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Txt.vue
// module id = null
// module chunks = 